import { render, staticRenderFns } from "./CompensationList.vue?vue&type=template&id=e602523e&scoped=true"
import script from "./CompensationList.vue?vue&type=script&lang=js"
export * from "./CompensationList.vue?vue&type=script&lang=js"
import style0 from "./CompensationList.vue?vue&type=style&index=0&id=e602523e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e602523e",
  null
  
)

export default component.exports